module.exports = __webpack_public_path__ + "static/media/warning-orange.d2ce8f22.svg";